import React, { useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import styled from "styled-components";
import Profile from "./Profile";
import Timeline from "./Timeline";
import Section from "./Section";
import SkillsList from "./SkillsList";
import LineSpacer from "./LineSpacer";
import PageBreak from "./PageBreak";
import data_en from "../data/cvData_en.json";
import data_de from "../data/cvData_de.json";
import NavigationBar from "./NavigationBar";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 80px;
  padding: 20px;
  min-height: 100vh;
  color: #333;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  
  @media screen and (max-width: 991px) {
    max-width: 100%;
  }

  @media print {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const TimelineHeadline = styled.h2`
  font-size: 1.6rem;
  font-weight: bold;
  font-variant: small-caps;
  margin: 30px 0 40px 236px;

  @media screen and (max-width: 991px) {
    margin-left: 80px;
  }

  @media print {
    margin: 20px 0 20px 200px;
  }
`;

const CV = () => {
  const [language, setLanguage] = useState("en");

  // Dynamically load the data based on the selected language
  const cvData = language === "de" ? data_de : data_en;

  // Get the UI texts dynamically
  const uiTexts = cvData?.uiTexts || {
    contact: "Contact",
    export: "Export",
    languageToggle: "DE / EN",
  };

  // Toggle language between English and German
  const handleLanguageToggle = () => {
    setLanguage(language === "en" ? "de" : "en");
  };

  // Reference for CV content
  const cvRef = useRef();

  // Function to export CV as PDF
  const handleExportPDF = useReactToPrint({
    contentRef: cvRef,
    documentTitle: "schmeier_anna_cv",
    onAfterPrint: () => console.log("Printing completed"),
  });

  return (
    <>
      <NavigationBar
        language={language}
        uiTexts={uiTexts}
        onLanguageToggle={handleLanguageToggle}
        onExportPDF={handleExportPDF}
      />
      <div ref={cvRef}>
        <Container>
          <Profile
            name={cvData.profile?.name}
            position={cvData.profile?.position}
            contactInfo={cvData.contactInfo}
          />
          <LineSpacer height="10px" lineWidth="720px" />
          <SkillsList skills={cvData.skillsList} />
          <LineSpacer height="10px" lineWidth="720px" />
          {cvData.timelines?.map((timeline, timelineIndex) => (
            <div key={timelineIndex}>
              <TimelineHeadline>{timeline.headline}</TimelineHeadline>
              <Timeline>
                {timeline.sections?.map((section, sectionIndex) => (
                  <React.Fragment key={sectionIndex}>
                    <Section
                      title={section.title}
                      date={section.date}
                      position={section.position}
                      description={section.description}
                      important={section.important}
                      items={section.items}
                    />
                    {timelineIndex === 0 && sectionIndex === 3 && (
                      <>
                        <PageBreak />
                      </>
                    )}
                  </React.Fragment>
                ))}
              </Timeline>
            </div>
          ))}
        </Container>
      </div>
    </>
  );
};

export default CV;
